/**
 * Contato comercial exibido na landing (seção de planos).
 *
 * O QR code em `public/qr-whatsapp-comercial.svg` é estático e codifica `https://wa.me/<número>`
 * (sem mensagem pré-preenchida, para ficar com poucos módulos e escanear fácil em qualquer tela).
 * O botão usa `commercialWhatsAppUrl()`, que abre o mesmo número com a mensagem padrão.
 * Se o número mudar, regenere o QR, por exemplo:
 *
 *   python3 -c "import segno; segno.make('https://wa.me/<número>', error='m').save( \
 *     'public/qr-whatsapp-comercial.svg', kind='svg', scale=1, border=2, dark='#0B1226', \
 *     light='#FFFFFF', xmldecl=False, omitsize=True)"
 */
export const COMMERCIAL_WHATSAPP_E164 = "5511991987000";
export const COMMERCIAL_WHATSAPP_DISPLAY = "(11) 99198-7000";
export const COMMERCIAL_EMAIL = "suporte@bytefy.com.br";
export const COMMERCIAL_WHATSAPP_MESSAGE = "Olá! Quero falar com o comercial do BaitaTicket.";
export const COMMERCIAL_QR_SRC = "/qr-whatsapp-comercial.svg";

export function commercialWhatsAppUrl(message: string = COMMERCIAL_WHATSAPP_MESSAGE): string {
  return `https://wa.me/${COMMERCIAL_WHATSAPP_E164}?text=${encodeURIComponent(message)}`;
}
